import React, { useContext, useCallback, useMemo, } from 'react';
import { TabContext } from './TabContext';
import { Icon, Input, Button } from '../../elements';
import { useEventListener } from '../../hooks';
import debounce from 'lodash/debounce';
export const TabSearch = ({ onChange, debounceWait = 200, }) => {
    const { state, setState } = useContext(TabContext);
    const dispatchOnChange = useMemo(() => {
        return debounce((searchTerm) => {
            if (onChange)
                onChange(searchTerm);
        }, debounceWait);
    }, [onChange, debounceWait]);
    const handleKeyPress = useCallback((event) => {
        if (state.searchTerm === undefined)
            setState((state) => (Object.assign(Object.assign({}, state), { searchTerm: '' })));
    }, [setState, state]);
    const handleBtnClick = useCallback(() => {
        setState((state) => (Object.assign(Object.assign({}, state), { searchTerm: '' })));
    }, [setState]);
    useEventListener('keypress', handleKeyPress);
    const handleSearchChange = useCallback((search) => {
        const searchTerm = search.toString();
        if (searchTerm === '') {
            setState((state) => (Object.assign(Object.assign({}, state), { searchTerm: undefined })));
        }
        else {
            setState((state) => (Object.assign(Object.assign({}, state), { searchTerm })));
        }
        dispatchOnChange(searchTerm);
    }, [setState]);
    const handleCancelSearch = useCallback(() => {
        dispatchOnChange(undefined);
        setState((state) => (Object.assign(Object.assign({}, state), { searchTerm: undefined })));
    }, [setState]);
    if (state.searchTerm !== undefined) {
        return (React.createElement("div", { className: "tabs__search" },
            React.createElement(Input, { value: state.searchTerm, onChange: handleSearchChange, icon: "search", autoFocus: true }),
            React.createElement(Button, { base: true, className: "ml--1", onClick: handleCancelSearch }, "Cancel")));
    }
    return (React.createElement("div", { className: "tabs__search-btn", onClick: handleBtnClick },
        React.createElement(Icon, { name: "search", className: "mr--0_5" }),
        "Start typing to search"));
};
//# sourceMappingURL=TabSearch.js.map